<script setup>

    defineProps({
        type: {
            type: String,
            default: 'button',
        },
        size: {
            type: String,
            default: 'sm'
        },
        emphasize: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            default: 'blue'
        },
        input_class: {
            type: String,
            default: ''
        }
    })

</script>

<template>
    <button
        :type="type"
        :class="[
            `inline-flex items-center justify-center px-4 bg-white rounded-md font-bold text-sm tracking-wider shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-25 transition ease-in-out duration-150 hover:bg-opacity-15`,
            {
                'border-lifeworx-blue-600 text-lifeworx-blue-600 focus:ring-lifeworx-blue-600 hover:bg-lifeworx-blue-600': color === 'blue',
                'border-lifeworx-green-600 text-lifeworx-green-600 focus:ring-lifeworx-green-600 hover:bg-lifeworx-green-600': color === 'green',
                'border-lifeworx-red-600 text-lifeworx-red-600 focus:ring-lifeworx-red-600 hover:bg-lifeworx-red-600': color === 'red',
                'border-lifeworx-orange-600 text-lifeworx-orange-600 focus:ring-lifeworx-orange-600 hover:bg-lifeworx-orange-600': color === 'orange',
                'border-lifeworx-purple-600 text-lifeworx-purple-600 focus:ring-lifeworx-purple-600 hover:bg-lifeworx-purple-600': color === 'purple',
                'border-2 text-sm py-3': size === 'sm',
                'border text-xs py-2': size === 'xs',
                'uppercase': emphasize,
            },
            input_class
        ]"
    >
        <slot />
    </button>

</template>
